import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageBanner from "../../../assets/images/andorra-license test-banner.png";
import SEO from "../../../utils/SEO";

export default function AndorraCarLicense (){

    return (
        <main className='main'>

            <SEO
                title="Andorra Car License | Offshore Advisory"
                description="Obtain your Andorra car license with Offshore Advisory. Expert guidance for residents, expats, and families to drive legally and safely in Andorra."
                keywords="Andorra car license, Andorra driving license, Andorra license conversion, Andorra license for residents, Andorra driving permit, expat car license Andorra, new license Andorra, Andorra family license, Andorra driving requirements"
                url="/andorra-car-license"
            />

            <IntroSection
                title="Andorra Car License | Offshore Advisory"
                description =
                    "
                    Drive legally and confidently in Andorra with a valid Andorra car license. Offshore Advisory provides comprehensive guidance for residents, expatriates, and international drivers seeking to obtain or convert a driving license in Andorra, ensuring a smooth, hassle-free process.
                    <br/>
                    <br/>
                    Andorra has strict regulations for vehicle registration and licensing, making it essential to comply with local laws to enjoy the freedom of driving in one of Europe’s most scenic and safe countries. Whether you are a new resident, a visitor planning to stay long-term, or an expatriate relocating for work, our expert team helps you navigate every step, from documentation to licensing tests, ensuring your driving privileges are recognized and valid.
                    <br/>
                    <br/>
                    With an Andorra car license, you gain the freedom to travel across the country, explore its mountainous terrain, and even drive within the Schengen Area if you meet certain conditions. Offshore Advisory makes the process transparent, fast, and fully compliant with Andorran traffic laws.
                    "
                buttonText="Contact Offshore Advisory Today! →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/andorra-car-license-hero.png")}
                imageAlt="Gaming License Intro"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose an Andorra Car License?'
                        subtitle="Obtaining an Andorra car license offers multiple benefits:"
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "Legal Driving Rights",
                                            text: "Drive confidently anywhere in Andorra and meet all local requirements."
                                        },
                                        {
                                            title: "International Recognition",
                                            text: "Convert foreign licenses if eligible, enabling smooth travel in Europe."
                                        },
                                        {
                                            title: "Safety and Compliance",
                                            text: "Adhere to Andorran traffic rules and regulations."
                                        },
                                        {
                                            title: "Convenience for Residents and Expats",
                                            text: "Essential for daily commuting, work, and leisure."
                                        },

                                    ]
                            }
                        ]}
                    />

                    <BannerPageImg src={PageBanner} />


                    <InfoBlocks
                        title="Andorra Car License Application Process"
                        subtitle='Our services cover all aspects of obtaining an Andorra driving license efficiently:'
                        blocks={[
                            {
                                items:
                                    [
                                        {
                                            title: "New License Issuance",
                                            text: "Guidance for first-time drivers meeting Andorran age and residency requirements."
                                        },
                                        {
                                            title: "License Conversion",
                                            text: "●Convert valid foreign driving licenses to Andorran licenses without unnecessary delays."
                                        },
                                        {
                                            title: "Documentation Support",
                                            text: "Assistance with ID verification, proof of residency, and medical certification."
                                        },
                                        {
                                            title: "Driving Test Preparation",
                                            text: "Support with theoretical and practical driving tests if required."
                                        },
                                    ]
                            }
                        ]}
                    />


                    <FeatureCards
                        title='Step-by-Step Andorra Car License Process'
                        subtitle='Offshore Advisory ensures a structured and stress-free process:'
                        features={
                            [
                                {
                                    title: "1. Consultation & Eligibility Check",
                                    text: "We assess your eligibility to obtain or convert an Andorra car license and explain all options based on your residency status and prior driving experience."
                                },
                                {
                                    title: "2. Documentation & Submission",
                                    text: "We help you gather all required documents, including ID, proof of residency, and any medical certificates, and submit your application to the relevant authorities."
                                },
                                {
                                    title: "3. Testing & Verification",
                                    text: "If required, we provide guidance for completing the theoretical and practical driving tests. For eligible foreign license holders, we coordinate the conversion process to save time."
                                },
                                {
                                    title: "4. License Issuance & Ongoing Support",
                                    text: "4.Once approved, we ensure you receive your official Andorra car license. Offshore Advisory continues to provide guidance on renewals, license upgrades, and compliance with local driving regulations."
                                },

                            ]
                        }
                    />

                    <LocationTimeline
                        title='Who Can Benefit?'
                        item={
                            [
                                { title: "New Residents", text: "Obtain a first-time Andorra car license efficiently." },
                                {
                                    title: "Expats and International Residents",
                                    text: "Convert foreign licenses and drive legally in Andorra."
                                },
                                {
                                    title: "High-Net-Worth Individuals & Investors",
                                    text: "Simplified license process to enjoy mobility during residency."
                                },
                                {
                                    title: "Families",
                                    text: "Assist spouses and dependents in obtaining valid licenses."
                                },

                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Our Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <DetailsSection
                        title='Why Choose Offshore Advisory?'
                        subtitle="With Offshore Advisory, you get:"
                        items={
                            [
                                { text: "Expert guidance on all Andorra car license requirements" },
                                { text: "Step-by-step support from document preparation to license issuance" },
                                { text: "Personalized assistance for residents, expats, and families" },
                                { text: "Ongoing help with renewals, upgrades, and compliance" },
                            ]
                        }
                    />

                    {/* Final CTA */}
                    <CTA title=
                             "
                             Contact Offshore Advisory Today!
                            "
                         description=
                             "
                             Ready to obtain your Andorra car license? Offshore Advisory makes the process simple, fast, and fully compliant.
                             "
                         buttonText='Get Started Today →'
                         buttonLink='/quote'
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Can I drive in Andorra with my foreign license?",
        answer: "Short-term visitors can drive with an international or EU license. Long-term residents may need to convert it to an Andorra license.",
    },
    {
        question: "How long does it take to get an Andorra car license?",
        answer: "Depending on your situation, it may take a few weeks to a few months for new licenses or conversions.",
    },
    {
        question: "Do I need to take a driving test?",
        answer: "Some foreign license holders may be exempt. First-time drivers must complete both theoretical and practical tests.",
    },
    {
        question: "Can my family members also get a license?",
        answer: "Yes. Spouses and eligible dependents can apply for their Andorra car license.",
    },
    {
        question: "Are there any age restrictions?",
        answer: "Yes. Applicants must meet the minimum driving age of 18 years for a standard car license in Andorra.",
    },

];

const testimonialsData =
    [
        {
            quote: "Thanks to Offshore Advisory, I got my Andorra car license quickly and without stress. The team was extremely helpful and responsive throughout.",
            author: "Elena F.",
            role: "Spain"
        },
        {
            quote: "I was relocating to Andorra and needed a local license. Offshore Advisory guided me step by step, making the process smooth and compliant.",
            author: "Markus W.",
            role: "Germany"
        }
    ]
;